import PythonDesignPatterns from './PythonDesignPatterns.js';

const localNotes = {
  'Python Design Patterns': PythonDesignPatterns,
};

export default localNotes;
